import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/features/auth/useAuth';

/**
 * Protège les routes enfants :
 * - pendant la restauration de session → écran de chargement ;
 * - non authentifié → redirection vers /login (mémorise la destination) ;
 * - permission optionnelle non satisfaite → page « accès refusé ».
 */
export function ProtectedRoute({ permission }: { permission?: string }) {
  const { status, hasPermission } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (permission && !hasPermission(permission)) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-24 text-center">
        <h1 className="text-xl font-semibold">Accès refusé</h1>
        <p className="text-sm text-muted-foreground">
          Vous n'avez pas la permission d'accéder à cette section.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
